import {
    AppBar,
    Box,
    Button,
    Card,
    CardHeader,
    Drawer,
    Grid,
    IconButton,
    List,
    ListItem,
    makeStyles,
    Paper,
    Theme,
    Toolbar,
    Typography,
} from '@material-ui/core';
import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useImperativeHandle,
    forwardRef,
    ForwardRefRenderFunction,
    Dispatch,
    SetStateAction,
    Fragment,
} from 'react';
import {
    member as v_member,
    basic,
    Values,
    product as v_product,
    order as v_order,
    SNACKBAR_TIME,
    FINISH_TIME,
} from '../../request/values';
import { Waypoint } from 'react-waypoint';

import NumberFormat from 'react-number-format';

import clsx from 'clsx';

import { COLORS } from '../Theme';

// Icon

import Dialog, { DialogConfirm } from '../Dialog';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { SIcon } from '../Icon';
import { useHistory } from 'react-router-dom';
import ToastStr from '../../request/toastStr';
import TitleBar from '../header/TitleBar';
import { TurnedIn } from '@material-ui/icons';
import { Toast } from 'react-bootstrap';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: 0,
        height: '88vh',
        width: '100vw',
        paddingTop: '3.5vh',
        background: `${COLORS.WHITE}`,
    },
    productItem: {
        borderRadius: 5,
        border: 'solid 1px #d3d3d3',
        margin: 'auto',
        marginBottom: '1.5vh',

        width: '90vw',
        padding: '20px',

        '& #itemWrap': {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px',
            '& #itemImage': {
                flex: 1,
                '& #itemImageSize': {
                    width: '100%',
                },
            },
            '& #itemDesc': {
                flex: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                '& #itemInfo': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    fontSize: '14px',
                    '& #itemName': {
                        backgroundColor: `${COLORS.WATER_BLUE}`,
                        color: `${COLORS.WHITE}`,
                        padding: '5px 10px',
                        borderRadius: '5px',
                    },
                    '& #itemLevel': {
                        backgroundColor: `${COLORS.WATER_BLUE}`,
                        color: `${COLORS.WHITE}`,
                        padding: '5px 10px',
                        borderRadius: '5px',
                    },
                },
                '& #productInfo': {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    gap: '5px',
                    fontSize: '12px',
                },
                '& #productPrice': {
                    width: '100%',
                    color: `${COLORS.WATER_BLUE}`,
                    margin: '10px 0',
                    fontSize: '16px',
                    fontWeight: 'bold',
                },
                '& #productButton': {
                    width: '100%',
                    backgroundColor: `${COLORS.WATER_BLUE}`,
                    color: `${COLORS.WHITE}`,
                    borderRadius: '10px',
                    border: 'none',
                    padding: '10px',
                    fontSize: '16px',
                    lineHeight: '20px',
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '5px',
                    '& #productButtonIcon': {
                        width: '20px',
                        height: '20px',
                    },
                },
            },
        },
        [theme.breakpoints.up('md')]: {
            width: '60vw',
            padding: '30px',
        },
    },

    list: {
        width: '100vw',
        height: '74vh',
        overflowY: 'auto',
        ...theme.typography.subtitle1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            width: '62vw',
            height: '100%',
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(6),
        },
    },
    empty: {
        height: '62vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '35vw',
            height: '35vw',
            [theme.breakpoints.up('md')]: {
                width: '25vw',
                height: '25vw',
            },
            marginBottom: '2.5vh',
            opacity: 0.4,
        },
        '& h1': {
            color: `${COLORS.DOWN}`,
        },
    },
    buttonWrapper: {
        textAlign: 'right',
        marginLeft: 'auto',
        paddingBottom: '1vh',
        paddingRight: '6vw',
        [theme.breakpoints.up('md')]: {
            paddingRight: '10px',
        },
    },
    button: {
        height: 'auto',
        borderRadius: '5px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.WHITE}`,
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        padding: '1vw',
        ...theme.typography.body1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        width: 'auto',
    },
}));

interface iproductList {
    productName: string;
    productNum: string;
    productImage: string;
    productPrice: number;
    quantity: number;
    companyName: string;
    companyNum: number;
    memberName: string;
    productLicenseLevel: number;
    productSaleAppNum: number;
    productSaleAppDate: string;
    productListPrice: number;
}

export interface refHandle {
    refreshCartList: () => void;
    handleOpen: () => void;
}

type iDialog = {
    open: boolean;
    type: string;
    index: number;
};

const ProductPurchase: React.FC<any> = (props) => {
    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const history = useHistory();
    const { member } = props;

    const count = 20;
    let max_count: number = 999;
    const loader = useRef(null);

    const [product, setProduct] = useState<iproductList[]>([]);
    const [page, setPage] = useState(-count);
    const [loading, setLoading] = useState(false);

    const [dialog, setDialog] = useState<iDialog>({
        open: false,
        type: 'approval',
        index: 0,
    });

    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + count > max_count) {
                    return prevState;
                }
                return prevState + count;
            });
        }
    }, []);

    const handleClose = () => {
        console.log('click close');
        setDialog((prevState: any) => {
            return Object.assign({}, prevState, { open: false });
        });
    };

    const handleApprovalOpen = (index: number) => {
        console.log(index);
        if (index >= 0) {
            setDialog((prevState: any) => {
                return Object.assign({}, prevState, {
                    open: true,
                    type: 'approval',
                    index: index,
                });
            });
        }
    };

    const moveProductOrderList = () => {
        history.push({
            pathname: '/ProductOrderList2',
        });
    };

    const postProductPurchase = (product: any) => {
        let url = new URL(
            basic.server + v_member.member + v_product.purchase_application
        );
        axios({
            method: 'POST',
            data: {
                companyNum: member.companyNum,
                product: product,
            },
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                // console.log(data)
                if (data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.PRODUCT_PURCHASE_SUCCESS, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    setProduct((prevState) => {
                        prevState.splice(dialog.index, 1);
                        return prevState.slice();
                    });
                } else if (data.code === Values.SALE_FINISH_CODE) {
                    enqueueSnackbar(ToastStr.PRODUCT_SALE_FINISH, {
                        variant: 'warning',
                        autoHideDuration: FINISH_TIME,
                        translate: 'no',
                    });
                } else if (data.code === Values.SALE_COMPANY_UPDATE_CODE) {
                    enqueueSnackbar(ToastStr.PRODUCT_SALE_COMPANY_UPDATE_STR, {
                        variant: 'warning',
                        autoHideDuration: FINISH_TIME,
                        translate: 'no',
                    });
                } else if (data.code === Values.INSUFFICIENT_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_STOCK_INSUFFICIENT_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code === Values.FAIL_CODE) {
                    if (data.msg)
                        enqueueSnackbar(data.msg, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    else
                        enqueueSnackbar(ToastStr.PRODUCT_PURCHASE_FAIL, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });

        handleClose();
    };

    async function getMaxProductCount(): Promise<number> {
        let url = new URL(
            basic.server + v_member.member + v_product.purchase_list
        );
        let params = {
            classCode: member.classCode,
            companyNum: member.companyNum,
        };
        url.search = new URLSearchParams(params).toString();

        const response = await axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        });
        const data = await response.data;
        const count: number = data.count.count;
        return count;
    }

    const getProductPurchaseAppList = (position: number, count: number) => {
        console.log('get');
        let url = new URL(
            basic.server + v_member.member + v_product.purchase_app_list
        );
        let params = {
            classCode: member.classCode,
            companyNum: member.companyNum,
            position: position.toString(),
            count: count.toString(),
            keyword: '',
        };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);

                if (data.code === Values.SUCCESS_CODE) {
                    setLoading(true);
                    if (product.length === 0 && data.products.length === 0) {
                        enqueueSnackbar(ToastStr.PRODUCT_APP_LIST_EMPTY_STR, {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else if (data.products === null) {
                        enqueueSnackbar(ToastStr.PRODUCT_APP_LIST_FAIL_STR, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    } else {
                        if (product.length === 0) {
                            setProduct((prevState) => data.products);
                        } else {
                            setProduct((prevState) =>
                                prevState.concat(data.products)
                            );
                        }
                    }
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code === Values.EXCEPTION_CODE) {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
                        variant: 'error',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                }
            });
    };

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: '20px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current!);
    }, [handleObserver]);

    useEffect(() => {
        if (page >= 0) {
            getProductPurchaseAppList(page, count);
            const tick = setInterval(() => {
                getProductPurchaseAppList(page, count);
            }, 1000 * 5);
            return () => clearTimeout(tick);
        }
    }, [page]);

    useEffect(() => {
        const init = async () => {
            max_count = await getMaxProductCount();
        };
        init();
    }, []);

    return (
        <div className="content">
            <TitleBar history={history} title="제품구매" titleIcon="cart" />

            <Box display="grid" justifyContent="center" alignItems="center">
                <div className={classes.buttonWrapper}>
                    <Button
                        className={classes.button}
                        onClick={moveProductOrderList}
                    >
                        제품 영수증
                    </Button>
                </div>
                <List className={classes.list}>
                    {product.length != 0 ? (
                        product.map((item: any, index) => {
                            return (
                                <ListItem
                                    className={classes.productItem}
                                    alignItems="center"
                                >
                                    <ProductItem
                                        {...item}
                                        approval={() =>
                                            handleApprovalOpen(index)
                                        }
                                        member={member}
                                    />
                                </ListItem>
                            );
                        })
                    ) : (
                        <div className={classes.empty}>
                            <div>
                                <img src="/images/title/cart.webp" />
                                <Typography variant="h1">
                                    제품 주문 내역이 없습니다.
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div ref={loader} />
                </List>
            </Box>

            <DialogConfirm
                open={dialog.open}
                handleClose={() => handleClose()}
                title={'상품을 구매하시겠습니까?'}
                // context={() => makeContext}
                /*
                context={
                    product.length !== 0
                    && `기업 : ${product[dialog.index].companyName}
                    상품 : ${product[dialog.index].productName}`
                }
                */
                yesConfirm={(e: any) =>
                    postProductPurchase(product[dialog.index])
                }
                noConfirm={() => handleClose()}
            />
        </div>
    );
};

const ProductItem: React.FC<any> = (props) => {
    const classes = useStyles();

    const { approval } = props;

    const AddComma = (num: number) => {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
    };

    return (
        <div id="itemWrap">
            <div id="itemImage">
                <img
                    id="itemImageSize"
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.productImage
                    }
                />
            </div>
            <div id="itemDesc">
                <div id="itemInfo">
                    <div id="itemName">{props.productName}</div>
                    <div id="itemLevel">
                        {'Lev. ' + props.productLicenseLevel}
                    </div>
                </div>
                <div id="productInfo">
                    <div id="productCompanyName">
                        {'제조사: ' + props.companyName}
                    </div>
                    {(props.member.classVersion === 4 ||
                        props.member.classVersion === 5) && (
                        <div id="productListPrice">
                            {'제품 정가: ' +
                                AddComma(props.productListPrice) +
                                '원'}
                        </div>
                    )}
                </div>
                <div id="productPrice">
                    {'판매 가격: ' + AddComma(props.productPrice) + '원'}
                </div>
                <button id="productButton" onClick={approval}>
                    <div>제품 구매하기</div>
                    <img
                        id="productButtonIcon"
                        src="/images/cursor_click_white.svg"
                    />
                </button>
            </div>
        </div>
    );
};

export default ProductPurchase;
